import React, { useCallback, useState } from 'react'
import { FieldPath, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import { Button, Link, Loader } from 'UI'
import showIconUrl from 'UI/Button/images/show.svg'
import { LinkStyles } from 'UI/Link/types'
import TaskStatus from 'containers/Courses/Entities/Tasks/TaskStatus'
import TaskPreview from 'containers/Courses/Entities/Tasks/Preview'
import { ButtonStyles } from 'UI/Button/types'
import TasksTabs from 'containers/Courses/Entities/Tasks/Tabs/Edit/Wrapper.container'

import { ITask } from 'types/models/task.model'
import { taskQuery } from 'store/queries'
import CancelChangeModal from 'pages/Course/modals/CancelChangeModal'
import { LoaderStyles } from 'UI/Loader/types'

import cl from '../style.module.scss'

export interface TaskFormState extends ITask<string> { }

const TaskEditPage = () => {
	const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false)

	const [isPreview, setIsPreview] = useState(false)
	const { courseId, taskId } = useParams()
	const {
		register,
		handleSubmit,
		setValue,
		control,
		watch,
		formState,
		getValues
	} = useForm<TaskFormState>()


	const changeHandler = useCallback(
		(name: FieldPath<TaskFormState>) => (value: any) => setValue(name, value),
		[]
	)

	const { data: currentTaskInfo } = taskQuery.useGetTaskQuery({
		taskId: Number(taskId)
	})

	if (!currentTaskInfo) {
		return <Loader styleTypes={[LoaderStyles.BIG]} />
	}

	return (
		<>
			<CancelChangeModal
				isOpen={cancelModalIsOpen}
				onClose={() => setCancelModalIsOpen(false)}
				redirectUri={`/course/edit/${courseId}`}
			/>
			<div className={cl.container}>
				<div className={cl.back}>
					<Link
						styleTypes={[LinkStyles.GO_BACK]}
						href={`/course/edit/${courseId}`}
					>
						Вернуться назад к курсу
					</Link>
				</div>
				<div className={cl.header}>
					<div className={cl.headerLessonInfo}>
						<h2>{currentTaskInfo.data.name}</h2>
						<TaskStatus
							taskId={+taskId!}
							restrictionsFilled={
								currentTaskInfo.data.passingScore > 0 &&
								currentTaskInfo.data.countAttempts > 0
							}
							isActive={currentTaskInfo.data.isActive}
							getValues={getValues}
						/>
					</div>
					<Button
						onClick={() => setIsPreview((prev) => !prev)}
						styleTypes={[ButtonStyles.ROUND, ButtonStyles.OUTLINE_DARK]}
					>
						{isPreview ? (
							'Вернуться к редактированию'
						) : (
							<>
								<img src={showIconUrl} alt="show" /> Предпросмотр
							</>
						)}
					</Button>
				</div>
				<TaskPreview getValues={getValues} isPreview={isPreview} />
				<TasksTabs
					onOpenCanceledChange={() => setCancelModalIsOpen(true)}
					setValue={setValue}
					currentTaskInfo={currentTaskInfo.data}
					handleSubmit={handleSubmit}
					errors={formState.errors}
					onChange={changeHandler}
					control={control}
					isPreview={isPreview}
					register={register}
					watch={watch}
					getValues={getValues}
				/>
			</div>
		</>
	)
}

export default TaskEditPage
